function OwnerBanner({companyLogo}){
  return(
    <img src={companyLogo} alt="company-logo" className="owner-banner"/>
  );
}

export default OwnerBanner;
